import React, { FC, useState } from 'react'
// import { useSearchContext } from 'search/context/SearchContext'

import { Button } from 'core/ui/Button/Buttons'
import { StatusWrapper, SelectedItems, StatusButtons } from './styled'
import { SwitchIcon } from 'images'
import { IconButton } from '@mui/material'
import ApproveRejectCommentModal from './ApproveRejectCommentModal'
import DelegateModal from './DelegateModal'

interface Props {
    selectedLength: number
    handleApprove: (comment: string) => Promise<void>
    handleReject: (comment: string) => Promise<void>
    handleDelegate: (comment: string, userId: string) => Promise<void>
}

const EmployeeApproveTableStatus: FC<Props> = ({
    selectedLength,
    handleApprove,
    handleReject,
    handleDelegate,
}) => {
    const [isDelegateModalOpen, setIsDelegateModalOpen] = useState(false)
    const [delegateCommentText, setDelegateCommentText] = useState('')

    const [isApproveRejectCommentModalOpen, setIsApproveRejectCommentModalOpen] = useState(false)
    const [commentModalType, setIsCommentModalType] = useState<'approve' | 'reject'>('approve')
    const [commentText, setCommentText] = useState('')

    const handleApproveAction = () => {
        setIsCommentModalType('approve')
        setIsApproveRejectCommentModalOpen((prev) => !prev)
    }
    const handleRejectAction = () => {
        setIsCommentModalType('reject')
        setIsApproveRejectCommentModalOpen((prev) => !prev)
    }
    const handleDelegateAction = () => {
        setIsDelegateModalOpen((prev) => !prev)
    }

    return selectedLength ? (
        <StatusWrapper>
            <SelectedItems>{selectedLength} items selected</SelectedItems>
            <StatusButtons>
                <Button variant="contained" onClick={handleApproveAction}>
                    Approve
                </Button>
                <Button variant="outlined" onClick={handleRejectAction}>
                    Reject
                </Button>
                <IconButton sx={{ padding: 0 }} onClick={handleDelegateAction}>
                    <SwitchIcon />
                </IconButton>
            </StatusButtons>
            <ApproveRejectCommentModal
                handleApprove={handleApprove}
                handleReject={handleReject}
                type={commentModalType}
                commentText={commentText}
                setCommentText={setCommentText}
                isOpen={isApproveRejectCommentModalOpen}
                onClose={() => setIsApproveRejectCommentModalOpen(false)}
            />
            <DelegateModal
                handleDelegate={handleDelegate}
                commentText={delegateCommentText}
                setCommentText={setDelegateCommentText}
                isOpen={isDelegateModalOpen}
                onClose={() => setIsDelegateModalOpen(false)}
            />
        </StatusWrapper>
    ) : null
}

export default EmployeeApproveTableStatus
